import React from 'react';
import { Empty } from 'antd';

export const renderReportCardPdfError = () => (
   <div className="report-card-pdf-error">
      <Empty
         image="../images/brainee_mascot.png"
         description={
            <div className="report-card-pdf-error-message">
               <strong>We couldn't open this report card preview.</strong>
               <span>Please try again later or contact the school office if this continues.</span>
            </div>
         }
      />
   </div>
);
